// extracted by css-extract-rspack-plugin
module.exports =  {"logout":"Logout-Ik4I__logout"};